// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3FNrF","col":"CardReaderDesc_col__omGYh","label":"CardReaderDesc_label__3BMAd"};